(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adamu-ai-summary"] && !Shopify.designMode) return;
  try {
    
(function() {

  // --- Expand/collapse summary text (mobile) ---
  var summaryBtn = document.querySelector('.adamu-ai-summary__expand');
  var summaryText = document.getElementById('ai-summary-text');
  if (summaryBtn && summaryText) {
    summaryBtn.addEventListener('click', function() {
      var expanded = summaryBtn.getAttribute('aria-expanded') === 'true';
      summaryBtn.setAttribute('aria-expanded', String(!expanded));
      summaryText.classList.toggle('is-expanded', !expanded);
    });
  }

  // --- Ingredient table: show/hide toggle ---
  // Rows 4+ are hidden via CSS class set in Liquid.
  // JS only needs to: reveal the button if hidden rows exist, and wire the click.
  var tableBody = document.querySelector('[data-table-body]');
  var toggleBtn = document.querySelector('[data-table-toggle]');
  var VISIBLE_COUNT = 3;

  if (tableBody && toggleBtn) {
    var hiddenRows = tableBody.querySelectorAll('.adamu-ntable__row--hidden');

    if (hiddenRows.length > 0) {
      // Show the toggle button
      toggleBtn.style.display = '';

      toggleBtn.addEventListener('click', function() {
        var expanded = toggleBtn.getAttribute('aria-expanded') === 'true';

        hiddenRows.forEach(function(row) {
          row.classList.toggle('adamu-ntable__row--hidden', expanded);
        });

        toggleBtn.setAttribute('aria-expanded', String(!expanded));
      });
    }
  }

  // --- Row scroll animations via IntersectionObserver ---
  var allRows = document.querySelectorAll('.adamu-ntable__row');
  if (!allRows.length) return;

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    allRows.forEach(function(row) { observer.observe(row); });
  } else {
    allRows.forEach(function(row) { row.classList.add('is-visible'); });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayuba-collection-chips"] && !Shopify.designMode) return;
  try {
    
  // Keep the current category pill in view on narrow screens (no page scroll, rail only).
  for (const rail of document.querySelectorAll('[data-ayuba-chip-rail]')) {
    const current = rail.querySelector('[aria-current="page"]');
    if (!current || rail.scrollWidth <= rail.clientWidth) continue;
    const left = current.offsetLeft - (rail.clientWidth - current.offsetWidth) / 2;
    rail.scrollLeft = Math.max(0, left);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayuba-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initFAQ(sectionEl) {
    var items = sectionEl.querySelectorAll('.ayuba-faq__item');

    items.forEach(function (item) {
      var btn    = item.querySelector('.ayuba-faq__question');
      var answer = item.querySelector('.ayuba-faq__answer');

      if (!btn || !answer) return;

      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        // Close all
        items.forEach(function (other) {
          var otherBtn    = other.querySelector('.ayuba-faq__question');
          var otherAnswer = other.querySelector('.ayuba-faq__answer');
          if (!otherBtn || !otherAnswer) return;

          other.classList.remove('is-open');
          otherBtn.setAttribute('aria-expanded', 'false');
          otherAnswer.classList.remove('is-visible');
        });

        // Open clicked (if it was closed)
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          answer.classList.add('is-visible');
        }
      });
    });
  }

  // Horizon section:load event
  document.addEventListener('DOMContentLoaded', function () {
    var sections = document.querySelectorAll('[data-section-type="ayuba-faq"]');
    sections.forEach(initFAQ);
  });

  // Theme editor live reload
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-section-type="ayuba-faq"]');
    if (section) initFAQ(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayuba-flavor-lines"] && !Shopify.designMode) return;
  try {
    
  // Hover/focus on a flavour chip previews that flavour's packshot in its card (links still navigate).
  document.addEventListener('pointerover', (event) => preview(event.target));
  document.addEventListener('focusin', (event) => preview(event.target));
  function preview(target) {
    if (!(target instanceof Element)) return;
    const chip = target.closest('[data-ayuba-flavor-src]');
    if (!chip) return;
    const image = chip.closest('.ayuba-flavors__card')?.querySelector('.ayuba-flavors__image');
    if (!image || image.dataset.current === chip.dataset.ayubaFlavorSrc) return;
    image.removeAttribute('srcset');
    image.src = chip.dataset.ayubaFlavorSrc;
    image.dataset.current = chip.dataset.ayubaFlavorSrc;
    // The image link follows the previewed flavour.
    const media = image.closest('a');
    if (media) media.href = chip.getAttribute('href');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayuba-product-assurance"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // The recap card has its own buy link; while it is on screen the sticky add-to-cart bar steps aside
    // (no doubled buy action). CSS reads the flag; Horizon's sticky logic stays untouched.
    const link = document.querySelector('.ayuba-product-recap__action');
    if (!link || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) document.documentElement.dataset.ayubaRecap = 'in-view';
      else delete document.documentElement.dataset.ayubaRecap;
    }).observe(link);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayuba-product-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const money = (input, attr) => (input ? input.dataset[attr] || '' : '');
    document.querySelectorAll('.ayuba-landing').forEach((landing) => {
      const form = landing.querySelector('.ayuba-landing__form');
      if (!form) return;
      const root = landing.closest('.shopify-section') || document;
      const bar = root.querySelector('[data-landing-bar]');
      const sync = () => {
        const picked = form.querySelector('input[name="id"]:checked');
        if (!picked) return;
        root.querySelectorAll('[data-landing-price]').forEach((el) => (el.textContent = money(picked, 'price')));
        const compare = form.querySelector('[data-landing-compare]');
        if (compare) compare.textContent = money(picked, 'compare');
        const unit = form.querySelector('[data-landing-unit]');
        if (unit) unit.textContent = money(picked, 'unit');
      };
      form.addEventListener('change', sync);
      const cta = form.querySelector('[data-landing-cta]');
      if (!bar || !cta || !('IntersectionObserver' in window)) return;
      bar.hidden = false;
      // Offer the buy action whenever the hero button is off screen, but step aside for the footer
      // (as the PDP's sticky bar does) so legal and service links are never covered.
      let ctaVisible = true;
      let footerVisible = false;
      let recapVisible = false;
      const update = () => {
        // The closing recap card has its own buy link: the bar steps aside there too (no doubled CTA).
        const show = !ctaVisible && !footerVisible && !recapVisible;
        bar.classList.toggle('is-visible', show);
        bar.inert = !show;
      };
      new IntersectionObserver(([entry]) => {
        ctaVisible = entry.isIntersecting;
        update();
      }).observe(cta);
      const recap = root.querySelector('.ayuba-product-recap__action');
      if (recap) {
        new IntersectionObserver(([entry]) => {
          recapVisible = entry.isIntersecting;
          update();
        }).observe(recap);
      }
      const footer = document.querySelector('footer');
      if (footer) {
        new IntersectionObserver(([entry]) => {
          footerVisible = entry.isIntersecting;
          update();
        }).observe(footer);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
